import { createRoot } from 'react-dom/client';
import { QueryProvider } from './app/providers';
import App from './App.tsx';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <QueryProvider>
    <App />
  </QueryProvider>
);
